import React from 'react'
import PropTypes from 'prop-types'
import moment from '../../../helpers/moment';

const PresentableDate = ({startDate, endDate}) => {
    const initDate = moment(startDate)
    const finishDate = moment(endDate)
    const now = moment()
    
    let message
    if (now.diff(initDate) < 0) {
        message = `Começa ${initDate.fromNow()}`
    } else if (now.diff(finishDate) < 0) {
        message = `Termina ${finishDate.fromNow()}`
    } else {
        message = `Concluído ${finishDate.fromNow()}`
    }


    return (<span className='presentable-date'>{message}</span>)
}

PresentableDate.propTypes = {
    startDate: PropTypes.Date,
    endDate: PropTypes.Date
}

PresentableDate.defaultProps = {
}

export default PresentableDate



// WEBPACK FOOTER //
// ./src/components/_common/PresentableDate/index.js